import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewEmployeeManual = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "#000000",
	width: "800px",
	height: "800px",
	viewBox: "0 0 64 64",
	id: "Layer_1_1_",
	xmlSpace: "preserve",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "M32,11c1.654,0,3-1.346,3-3s-1.346-3-3-3s-3,1.346-3,3S30.346,11,32,11z M32,7c0.551,0,1,0.448,1,1s-0.449,1-1,1   s-1-0.448-1-1S31.449,7,32,7z" }),
		/* @__PURE__ */ _jsx("path", { d: "M37,25h-2V13h-8v6h2v6h-2v6h10V25z M35,29h-6v-2h2V17h-2v-2h4v12h2V29z" }),
		/* @__PURE__ */ _jsx("path", { d: "M59,15v-2H48.247C46.107,6.059,39.634,1,32,1S17.893,6.059,15.753,13H5v2H1v44h26.101c0.464,2.279,2.485,4,4.899,4   s4.435-1.721,4.899-4H63V15H59z M32,3c8.271,0,15,6.729,15,15c0,7.124-5.063,13.308-12.039,14.705l-0.479,0.096L32,37.764   l-2.481-4.963l-0.479-0.096C22.063,31.308,17,25.124,17,18C17,9.729,23.729,3,32,3z M37,34.24c1.045-0.321,2.046-0.735,2.989-1.24   H53v12H37V34.24z M7,15h8.281C15.107,15.976,15,16.975,15,18c0,7.908,5.506,14.795,13.163,16.562L32,42.236l3-6.001V47h20V31   H42.921C46.659,27.848,49,23.146,49,18c0-1.025-0.107-2.024-0.281-3H57v38H33v-9h-2v9H7V15z M61,57H35v1c0,1.654-1.346,3-3,3   s-3-1.346-3-3v-1H3V17h2v38h54V17h2V57z" }),
		/* @__PURE__ */ _jsx("rect", {
			height: 2,
			width: 20,
			x: 9,
			y: 49
		}),
		/* @__PURE__ */ _jsx("rect", {
			height: 2,
			width: 20,
			x: 9,
			y: 45
		}),
		/* @__PURE__ */ _jsx("rect", {
			height: 2,
			width: 20,
			x: 9,
			y: 41
		}),
		/* @__PURE__ */ _jsx("rect", {
			height: 2,
			width: 18,
			x: 9,
			y: 37
		}),
		/* @__PURE__ */ _jsx("rect", {
			height: 2,
			width: 20,
			x: 35,
			y: 49
		})
	] })
});
export default SvgNewEmployeeManual;
